import Tooltip from "@/Components/UI/Tooltip";
import { LoadsClientAttributes } from "@/types/clientAttributes";
import { LoadsMatchingAttributes } from "@/types/matchingAttribute";
import { Client, Coach } from "@/types/page";
import { hasNeurodivergentMatch } from "@/utils/hasNeurodivergenceMatch";
import { RiInformationLine } from "react-icons/ri";

type NeurodivergentCoachTagProps = {
    client: Client & LoadsClientAttributes;
    coach: Coach & LoadsMatchingAttributes;
    overrideBgColor?: string;
};

export default function NeurodivergentCoachTag({
    client,
    coach,
    overrideBgColor,
}: NeurodivergentCoachTagProps) {
    if (hasNeurodivergentMatch(client, coach)) {
        return (
            <div
                className="flex w-fit rounded-full bg-brand-lightRed px-3 py-1 text-xs font-medium text-brand-black"
                style={{
                    backgroundColor: overrideBgColor,
                }}
            >
                EXPERTISE WITH NEURODIVERGENT CLIENTS{" "}
                <Tooltip
                    title="The coach has either training for coaching and/or successfully coached multiple neurodivergent clients."
                    trigger="click"
                    position="top"
                >
                    <RiInformationLine
                        className="text-brand-black ml-1 cursor-pointer"
                        size={14}
                    />
                </Tooltip>
            </div>
        );
    }
    return null;
}
